// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".correct-text-answers[data-v-1b2758aa]{display:flex;flex-direction:column;align-items:flex-start;width:100%;position:relative}.columns[data-v-1b2758aa]{display:flex;width:100%;margin-bottom:5px}.title[data-v-1b2758aa]{margin-bottom:10px}.correct-match[data-v-1b2758aa],.scope[data-v-1b2758aa]{width:50%;font-weight:700;font-size:1rem;color:#0f2345}.scope[data-v-1b2758aa]{width:193px}.variant[data-v-1b2758aa]{font-weight:400}", ""]);
// Exports
module.exports = exports;
